import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BookingService } from 'libraries/service/booking/booking.service';
import { IGetBookingsCommonResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { faPlane, IconDefinition, faFolder, faBed, faCar } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'booking',
    template: `
        <ng-container *ngIf="booking">
            <ng-container *ngIf="!booking.type || !booking.type.length || !isTypeSupported()">
                <fa-icon [icon]="folder"></fa-icon>
                <booking-header [booking]="booking" [processingId]="processingId"></booking-header>
            </ng-container>
            <ng-container *ngIf="isAirBooking()">
                <fa-icon [icon]="plane"></fa-icon>
                <booking-air [booking]="booking" [processingId]="processingId"></booking-air>
            </ng-container>
            <ng-container *ngIf="isHotelBooking()">
                <fa-icon [icon]="bed"></fa-icon>
                <booking-hotel [booking]="booking" [processingId]="processingId"></booking-hotel>
            </ng-container>
            <ng-container *ngIf="isVehicleRentalBooking()">
                <fa-icon [icon]="car"></fa-icon>
                <booking-vehicle-rental [booking]="booking" [processingId]="processingId"></booking-vehicle-rental>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!booking">{{noBookingLabel}}</ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        :host {
            display: flex;
        }

        fa-icon {
            margin-right: .75rem;
            width: 20px;
        }

        booking-air,
        booking-hotel,
        booking-vehicle-rental {
            flex: 1;
            display: block;
        }
    `]
})
export class BookingComponent {

    /**
     * in case we open the booking from a processing page, modify the url and breadcrumb
     */
    @Input()
    public processingId: number;

    @Input()
    public booking: IGetBookingsCommonResponse;

    @Input()
    public noBookingLabel?: string = '?';

    public plane: IconDefinition = faPlane;
    public folder: IconDefinition = faFolder;
    public bed: IconDefinition = faBed;
    public car: IconDefinition = faCar;

    constructor(
        private readonly bookingService: BookingService
    ) {
    }

    public isAirBooking(): boolean {
        return this.bookingService.isAirBooking(this.booking);
    }

    public isHotelBooking(): boolean {
        return this.bookingService.isHotelBooking(this.booking);
    }

    public isVehicleRentalBooking(): boolean {
        return this.bookingService.isVehicleRentalBooking(this.booking);
    }

    public isTypeSupported(): boolean {
        return this.isAirBooking() || this.isHotelBooking() || this.isVehicleRentalBooking();
    }
}
